import { MantineTheme } from "@mantine/styles";

import { ThemeComponent } from "./helpers.ts";

const errorText = (theme: MantineTheme) => ({
  root: {
    color: theme.colors.error[0],
  },
});

export default function textTheme(): ThemeComponent {
  return {
    variants: {
      error: errorText,
    },
  };
}
